import { createTheme, Theme as MuiTheme } from '@material-ui/core/styles';
import { colors } from './colors';
import { breakpoints, fontSizes, lineHeights, space } from './scales';

/**
 * Styled Components theme
 */
export const theme = {
  breakpoints,
  colors,
  fontFamily: {
    montserrat: 'Montserrat',
    poppins: 'Poppins',
  },
  fontSizes,
  lineHeights,
  space,
  sizes: {
    inputHeight: '56px',
  },
  navbar: {
    primaryToolbarHeight: 72,
    secondaryToolbarHeight: 32,
  },
};

type StyledComponentTheme = typeof theme;

/**
 * Material UI Theme, created from the styled components theme
 */
export const muiTheme = themeToMuiTheme(theme);

/**
 * Converts our custom theme object to a valid Material UI theme
 * object (`muiTheme`).
 * Default values: https://v4.mui.com/customization/default-theme/
 */
function themeToMuiTheme(theme: StyledComponentTheme): MuiTheme {
  return createTheme({
    palette: {
      primary: {
        light: theme.colors.primaryLight,
        main: theme.colors.primary,
        dark: theme.colors.primaryDark,
      },
      secondary: {
        light: theme.colors.secondaryLight,
        main: theme.colors.secondary,
        dark: theme.colors.secondaryDark,
      },
      error: {
        main: theme.colors.status.error.fill,
      },
      background: {
        default: theme.colors.background,
      },
      action: {
        disabledBackground: theme.colors.backgroundDisabled,
      },
    },
    typography: {
      fontSize: 14,
      fontFamily: theme.fontFamily.poppins,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 600,
    },
    overrides: {
      MuiTypography: {
        root: {
          fontFamily: theme.fontFamily.poppins,
          fontSize: 14,
        },
      },
    },
  });
}
